module.exports = __webpack_public_path__ + "static/media/ellipse1.6de7b101.png";